/**
 * Shared single-flight state for POST /api/rest/app/v1/users/me.
 *
 * Both provisionUser.ts (httpClient path) and jitProvision.ts (raw-fetch path)
 * import this module so that concurrent calls from either code path collapse into
 * a single in-flight HTTP request.  This module has no imports — it is a pure
 * mutable-state island — which keeps it out of every circular-import chain.
 */
export let provisioningFlight: Promise<void> | null = null;

export const setProvisioningFlight = (p: Promise<void> | null): void => {
  provisioningFlight = p;
};
